import { ReactNode, useEffect, useState } from 'react'
import classes from './RowProgress.module.css'
import { Typography } from '../../common/typography'
import clsx from 'clsx'
import { Fmt } from '../../widgets/format'
import { Box } from '@mantine/core'
export default function RowProgress({
  title,
  value,
  color,
  valueLabel,
}: {
  title: string
  value: number
  color?: string
  valueLabel?: ReactNode
}) {
  const width = 400
  const height = 16
  const progressWidth = Math.min(value * width, width)
  const isComplete = value >= 1

  const [animatedWidth, setAnimatedWidth] = useState(0)

  useEffect(() => {
    const timer = setTimeout(() => {
      setAnimatedWidth(progressWidth)
    }, 200)
    return () => clearTimeout(timer)
  }, [progressWidth])

  return (
    <div className={classes.container}>
      <Typography fs="xxxl" fc={{ light: 'gray-3', dark: 'gray-3' }} lh="100">
        {title}
      </Typography>
      <div className={classes.rowWrapper}>
        <svg
          viewBox={`0 0 ${width} ${height}`}
          className={classes.progressSvg}
          preserveAspectRatio="none"
        >
          <rect
            x="0"
            y="0"
            width={width}
            height={height}
            className={classes.backgroundBar}
            rx="4"
          />
          {isComplete ? (
            <rect
              x="0"
              y="0"
              width={animatedWidth}
              height={height}
              rx="4"
              className={clsx(classes.progressBar, {
                [classes.orange]: !color && value > 0.7 && value < 1,
                [classes.red]: !color && value <= 0.7,
              })}
              style={color ? { fill: color } : undefined}
            />
          ) : (
            <path
              d={`
              M 4 0
              L ${animatedWidth} 0
              L ${animatedWidth} ${height}
              L 4 ${height}
              Q 0 ${height} 0 ${height - 4}
              L 0 4
              Q 0 0 4 0
              Z
            `}
              className={clsx(classes.progressBar, {
                [classes.orange]: !color && value > 90 && value < 100,
                [classes.red]: !color && value <= 90,
              })}
              style={color ? { fill: color } : undefined}
            />
          )}
        </svg>
        <Box style={{ color: 'white', fontSize: '24px' }}>
          {valueLabel ?? (
            <Fmt
              value={value}
              metric=""
              component="percent"
              statistic="value"
            />
          )}
        </Box>
      </div>
    </div>
  )
}
